<template lang="pug">
  component(
    :is="$attrs.href ? 'a' : 'button'",
    :type="$attrs.href ? undefined : 'button'",
    :class="accentClasses.row",
    class="group flex w-full items-center rounded-lg border border-gray-400 bg-white px-5 py-4 text-left transition-colors",
    v-on="$listeners"
  )
    Icon(:icon="icon", :class="accentClasses.icon", class="flex-shrink-0 text-lg")
    span.ml-4.min-w-0.flex-1
      strong.block.font-semibold.text-heading {{ title }}
      span.mt-1.block.text-paragraph {{ description }}
    Icon(v-if="trailingIcon", :icon="trailingIcon", :class="accentClasses.trailing", class="ml-4 flex-shrink-0 text-supplement transition-colors")
</template>

<script>
// Full class names are listed so Tailwind's JIT can find them.
const accents = {
  primary: {
    row: "hover:border-primary-300 hover:bg-primary-50",
    icon: "text-primary-default",
    trailing: "group-hover:text-primary-default"
  },
  // Co-branding
  secondary: {
    row: "hover:border-secondary-300 hover:bg-secondary-50",
    icon: "text-secondary-default",
    trailing: "group-hover:text-secondary-default"
  },
  // Direct communications
  orange: {
    row: "hover:border-orange-300 hover:bg-orange-100",
    icon: "text-orange-600",
    trailing: "group-hover:text-orange-600"
  }
}

export default {
  props: {
    icon: {
      type: String,
      required: true
    },
    trailingIcon: {
      type: String
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    accent: {
      type: String,
      default: "primary",
      validator: value => Object.keys(accents).includes(value)
    }
  },
  computed: {
    accentClasses() {
      return accents[this.accent]
    }
  }
}
</script>
